package net.zagart.ai.core.app

import androidx.compose.runtime.*
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import kotlinx.browser.document
import net.zagart.ai.core.client.deepseek.DeepseekConfig
import net.zagart.ai.core.client.deepseek.getDeepseekApiKey

const val APP_VERSION = 7
private const val WORKER_API_BASE = "https://interactive-story.zagart.net/api"
private const val WORKER_PROXY_URL = "$WORKER_API_BASE/deepseek-proxy"

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    document.title = "AI Story Tester v$APP_VERSION"
    ComposeViewport(viewportContainerId = "root") {
        var config by remember { mutableStateOf<DeepseekConfig?>(null) }
        var configError by remember { mutableStateOf<String?>(null) }

        LaunchedEffect(Unit) {
            try {
                val apiKey = getDeepseekApiKey(WORKER_API_BASE)
                config = DeepseekConfig(apiKey = apiKey, baseUrl = WORKER_PROXY_URL)
            } catch (e: Exception) {
                configError = e.message ?: "Failed to load config"
            }
        }

        when {
            config != null -> StoryScreen(deepseekConfig = config!!, appVersion = APP_VERSION)
            configError != null -> StoryScreen(
                deepseekConfig = DeepseekConfig(apiKey = "", baseUrl = WORKER_PROXY_URL),
                appVersion = APP_VERSION
            )
        }
    }
}